<template>
  <div>

      <draggable v-model="itemsList"
                 @end="changed($event)"
                 @start="drag = true"
                 :animation="300"
                 ghostClass="ghost"
                 handle=".drag-indicator">
        <transition-group type="transition" class="catalog" v-if="categories">
            <catalog-category v-for="category in itemsList" :key="category.id" :category="category"></catalog-category>
        </transition-group>
      </draggable>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import CatalogCategory from './CatalogCategory';
    import draggable from 'vuedraggable'

    export default {
        name: "Catalog",
        components: {
            CatalogCategory,
            draggable
        },
        data() {
            return {
                itemsList: [],
                drag: false,
            }
        },
        props: [
            'categories'
        ],
        computed: {
            ...mapGetters('auth', [
                'user'
            ])
        },
        mounted() {
            this.updateItemsList();
        },
        watch: {
            categories: function() {
                this.updateItemsList();
            }
        },
        methods: {
            ...mapActions('catalog', [
                'updateCategoryOrder'
            ]),
            updateItemsList: function() {
                this.itemsList = this.categories
            },
            changed: async function (event) {
                this.drag = false
                if(event.newIndex !== event.oldIndex) {
                    let payload = {
                        items: this.itemsList,
                        location_id: this.user.locationId
                    }
                    await this.updateCategoryOrder(payload)
                }
            }
        }
    }
</script>

<style>
  .ghost {
    opacity: 0.5;
  }

  .move {
    transform: scale(.5);
  }
</style>

